import { useEffect, useRef, useState } from 'react';

export default function AboutSection() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const achievements = [
    { number: '10+', label: 'години практически опит' },
    { number: '2016', label: 'година на начало на професионалната дейност' },
    { number: 'МИРЭА + LBS', label: 'техническо и бизнес образование' },
    { number: 'Международен', label: 'глобални пазари и стратегии' },
  ];

  return (
    <section
      id="about"
      ref={sectionRef}
      className="relative py-24 lg:py-32 bg-[#F8F9FA]"
    >
      <div className="container mx-auto px-6 lg:px-12">
        {/* Label */}
        <div className="mb-8">
          <span className="text-sm uppercase tracking-[3px] text-[#D4AF37] font-semibold">
            За специалиста
          </span>
        </div>

        {/* Description */}
        <div 
          className={`max-w-4xl mb-20 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <p className="text-xl lg:text-2xl text-[#2C3E50] leading-relaxed mb-6 font-['Inter']">
            <strong>35 години</strong> (роден на 7 октомври 1990 г.) — професионален участник на финансовите пазари от 2016 г.
            Повече от <strong>10 години практически опит</strong> в областта на инвестициите, управлението на капитал и стратегическото управление на риска.
            Работи с различни класове активи, съчетавайки фундаментален и количествен анализ с дисциплинирана система за вземане на решения.
          </p>
          <p className="text-xl lg:text-2xl text-[#2C3E50] leading-relaxed font-['Inter']">
            Притежава техническо образование, завършил <strong>МИРЭА — Руски технологичен университет</strong> по специалност „Програмиране".
            Продължил обучението си в <strong>London Business School</strong>, където се специализирал в инвестиционни рискове, управление на портфейл и стратегическо финансово планиране.
          </p>
        </div>

        {/* Achievement cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-10">
          {achievements.map((item, index) => (
            <div
              key={index}
              className={`bg-white border border-[#D4AF37] rounded-3xl p-10 shadow-lg transition-all duration-700 hover:-translate-y-2 hover:shadow-2xl cursor-pointer ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <div className="text-4xl lg:text-5xl font-bold text-[#D4AF37] mb-4 font-['Playfair_Display']">
                {item.number}
              </div>
              <div className="text-base lg:text-lg text-[#6B7280] font-['Inter']">
                {item.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
